import { Check, Clock3, XCircle } from "lucide-react";
import { fmtDateTime } from "../lib/api";

export function TrackingTimeline({ events }) {
  return (
    <ol className="relative ml-2 mt-2 space-y-6 border-l-2 border-slate-200 pl-6" data-testid="tracking-timeline">
      {events.map((ev, i) => (
        <li key={i} className="relative" data-testid={`tracking-event-${ev.key}`}>
          <span className={`absolute -left-[31px] flex h-6 w-6 items-center justify-center rounded-full border-2 ${
            ev.state === "done" ? "border-emerald-500 bg-emerald-500 text-white"
            : ev.state === "refunded" ? "border-emerald-600 bg-emerald-600 text-white"
            : ev.state === "rejected" ? "border-red-500 bg-red-500 text-white"
            : "border-slate-300 bg-white text-slate-400"}`}>
            {ev.state === "done" || ev.state === "refunded" ? <Check size={12} />
             : ev.state === "rejected" ? <XCircle size={12} /> : <Clock3 size={12} />}
          </span>
          <p className={`text-sm font-semibold ${ev.state === "pending" ? "text-slate-400" : "text-navy"}`}>{ev.label}</p>
          {ev.at && <p className="font-mono text-[11px] text-slate-400">{fmtDateTime(ev.at)}</p>}
          {ev.detail && <p className="mt-0.5 text-xs leading-relaxed text-slate-500">{ev.detail}</p>}
        </li>
      ))}
    </ol>
  );
}
